"use client";

import { c as _c } from "react/compiler-runtime";
import { useRef, useState } from "react";
import { motion } from "framer-motion";
import Container from "../wrapper/Container";
import SectionSubHeading from "../common/titles/SectionSubHeading";
import SectionTitle from "../common/titles/SectionTitle";
import HouseRuleRow from "../common/cards/HouseRuleRow";
import RulePreviewCard from "../common/cards/RulePreviewCard";
import { houseRules } from "@/data/HouseRulesData";
import { rise } from "@/lib/animation/variant";
import { useCursorPreview } from "@/hooks/ui/useCursorPreview";
const HouseRules = () => {
  const $ = _c(15);
  const listRef = useRef(null);
  const [hovered, setHovered] = useState(null);
  const {
    x,
    y,
    onMouseMove
  } = useCursorPreview(listRef);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div aria-hidden={true} className="pointer-events-none absolute inset-0 opacity-30" style={{
      backgroundImage: "linear-gradient(to right, rgba(178,209,39,0.06) 1px, transparent 1px), linear-gradient(to bottom, rgba(178,209,39,0.06) 1px, transparent 1px)",
      backgroundSize: "80px 80px"
    }} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      once: true,
      amount: 0.5
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <SectionSubHeading subtitle="How we work" className="text-primary" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <motion.div variants={rise} initial="hidden" whileInView="show" viewport={t1} className="max-w-2xl space-y-2">{t2}<SectionTitle title={<>HOUSE <br /> RULES.</>} className="font-black text-white" /></motion.div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <motion.p variants={rise} initial="hidden" whileInView="show" viewport={{
      once: true,
      amount: 0.5
    }} custom={1} className="mt-5 max-w-xl text-base leading-relaxed text-white/50 md:text-lg">Four positions we do not trade away. Point at one to see the work that earned it.</motion.p>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = hovered === null ? null : houseRules[hovered];
  let t6;
  if ($[5] !== t5 || $[6] !== x || $[7] !== y) {
    t6 = <RulePreviewCard rule={t5} x={x} y={y} />;
    $[5] = t5;
    $[6] = x;
    $[7] = y;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== hovered) {
    t7 = houseRules.map((rule, i) => <HouseRuleRow key={rule.number} rule={rule} index={i} active={hovered === i} onHover={setHovered} />);
    $[9] = hovered;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== onMouseMove || $[12] !== t6 || $[13] !== t7) {
    t8 = <section className="relative w-full bg-card-foreground py-20 md:py-24 lg:py-32 rounded-b-4xl">{t0}<Container className="relative px-4 lg:px-10">{t3}{t4}<div ref={listRef} onMouseMove={onMouseMove} className="relative mt-14 border-t border-white/10 lg:mt-20">{t6}{t7}</div></Container></section>;
    $[11] = onMouseMove;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
};
export default HouseRules;